import { render, staticRenderFns } from "./orderPanel.vue?vue&type=template&id=16995f9d&scoped=true&"
import script from "./orderPanel.vue?vue&type=script&lang=js&"
export * from "./orderPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16995f9d",
  null
  
)

export default component.exports